<script setup>
import { reactive, ref, watch, inject, computed } from "vue";
import { Icon } from "@iconify/vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const props = defineProps({
  pageId: { type: Number, required: true },
  element: { type: Object, required: true },
  websiteId: { type: Number, required: true },
});
const { t } = useI18n();

const router = useRouter();
const openEditView = () => {
  router.push({
    name: "pages.element.edit",
    params: {
      websiteId: props.websiteId,
      pageId: props.pageId,
      elementId: props.element.id,
    },
  });
};
</script>

<template>
  <div class="edit-element">
    <div class="edit-btn">
      <Icon icon="bi:pencil" width="48" height="48" @click="openEditView" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.edit-element {
  background: #fff;
  border-radius: 50%;
  position: absolute;
  padding: 6px;
  border-radius: 6px;
  border: 2px solid #000;
}
</style>